module.exports = __webpack_public_path__ + "img/BJ.2ceb351d.svg";